import React, { useState, createContext } from 'react';

const PermissionContext = React.createContext();

export function PermissionProvider(props) {
  const [permissions, setPermissions] = useState({
    userPermissions: {
      hasChoseiPermission: false,
      hasRoumuPermission: false,
      hasNyutaiPermission: false,
    },
  });

  /**
   * userPermissions内の権限を更新する
   *
   * @param {string} permissionName - 更新する権限の関数名
   * @param {boolean} newValue- 更新する権限の新値
   */
  const handleUpdatePermission = (permissionName, newValue) => {
    const updatedPermissions = { ...permissions };
    updatedPermissions.userPermissions = { ...permissions.userPermissions };
    updatedPermissions.userPermissions[permissionName] = newValue;
    setPermissions(updatedPermissions);
  };

  const contextValue = {
    ...permissions,
    handleUpdatePermission,
  };

  return <PermissionContext.Provider value={contextValue} {...props} />;
}

export const PermissionConsumer = PermissionContext.Consumer;
export default PermissionContext;



// WEBPACK FOOTER //
// ./src/utilities/PermissionContext.js